import {http} from 'hiya-common/src/utils/axios'

import {
  UnionCityWarGotoMock,
  UnionCityWarGroupsMock,
  UnionCityWarHomepageMock,
  UnionCityWarLevelRewardClaimMock,
  UnionCityWarPkListMock,
  UnionCityWarPkSearchMock,
  UnionCityWarPkSwitchDisableMock,
  UnionCityWarPkSwitchEnableMock,
  UnionCityWarRankEmptyMock,
  UnionCityWarRankMock,
  UnionCityWarRankPage2Mock,
  UnionCityWarRankZoneFullListMock,
  UnionCityWarRankZoneFullListPage2Mock,
  UnionCityWarRemindMock,
  UnionCityWarRulesMock,
  UnionCityWarScoreRecordGiftMock,
  UnionCityWarScoreRecordPkMock,
  UnionCityWarScoreRecordTaskMock,
} from './mockMd'
import {
  UnionCityWarScoreRecordType,
  UnionCityWarStage,
  type UnionCityWarGotoData,
  type UnionCityWarGroupsData,
  type UnionCityWarHomepageData,
  type UnionCityWarLevelRewardClaimData,
  type UnionCityWarPkListData,
  type UnionCityWarPkSwitchData,
  type UnionCityWarRankData,
  type UnionCityWarRemindData,
  type UnionCityWarRulesData,
  type UnionCityWarScoreRecordData,
} from './types'

/** 本地 Mock 开关：开发 / dev 预览 / 叠图 true，联调/上线前改 false */
export const SERVICE_MOCK_ENABLED = false

/** @see mockMd/union_city_war_homepage.md */
export async function union_city_war_homepage(
  params: Record<string, unknown> = {}
): Promise<UnionCityWarHomepageData> {
  if (SERVICE_MOCK_ENABLED) {
    return UnionCityWarHomepageMock
  }

  const res = await http.post(
    '/live/activity/union_city_war_homepage',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/union_city_war_groups.md */
export async function union_city_war_groups(
  params: {stage?: number} = {}
): Promise<UnionCityWarGroupsData> {
  if (SERVICE_MOCK_ENABLED) {
    return UnionCityWarGroupsMock
  }

  const res = await http.post(
    '/live/activity/union_city_war_groups',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/union_city_war_rank.md · page 分页，每页 10 */
export async function union_city_war_rank(params: {
  stage: number
  group: number
  page?: number
}): Promise<UnionCityWarRankData> {
  if (SERVICE_MOCK_ENABLED) {
    const page = params.page && params.page > 0 ? params.page : 1
    if (page > 1) {
      if (params.group === 1) {
        return UnionCityWarRankZoneFullListPage2Mock
      }
      return UnionCityWarRankPage2Mock
    }
    if (params.group === 1) {
      return UnionCityWarRankZoneFullListMock
    }
    return UnionCityWarRankMock
  }

  const res = await http.post(
    '/live/activity/union_city_war_rank',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/union_city_war_goto.md */
export async function union_city_war_goto(
  params: Record<string, unknown> = {}
): Promise<UnionCityWarGotoData> {
  if (SERVICE_MOCK_ENABLED) {
    return UnionCityWarGotoMock
  }

  const res = await http.post(
    '/live/activity/union_city_war_goto',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/union_city_war_remind.md */
export async function union_city_war_remind(
  params: Record<string, unknown> = {}
): Promise<UnionCityWarRemindData> {
  if (SERVICE_MOCK_ENABLED) {
    return UnionCityWarRemindMock
  }

  const res = await http.post(
    '/live/activity/union_city_war_remind',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/union_city_war_pk_switch.md */
export async function union_city_war_pk_switch(params: {
  enable: boolean
}): Promise<UnionCityWarPkSwitchData> {
  if (SERVICE_MOCK_ENABLED) {
    return params.enable
      ? UnionCityWarPkSwitchEnableMock
      : UnionCityWarPkSwitchDisableMock
  }

  const res = await http.post(
    '/live/activity/union_city_war_pk_switch',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/union_city_war_level_reward_claim.md */
export async function union_city_war_level_reward_claim(params: {
  level: number
}): Promise<UnionCityWarLevelRewardClaimData> {
  if (SERVICE_MOCK_ENABLED) {
    return UnionCityWarLevelRewardClaimMock
  }

  const res = await http.post(
    '/live/activity/union_city_war_level_reward_claim',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/union_city_war_rules.md */
export async function union_city_war_rules(
  params: Record<string, unknown> = {}
): Promise<UnionCityWarRulesData> {
  if (SERVICE_MOCK_ENABLED) {
    return UnionCityWarRulesMock
  }

  const res = await http.post(
    '/live/activity/union_city_war_rules',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/union_city_war_score_record.md */
export async function union_city_war_score_record(params: {
  type: UnionCityWarScoreRecordType
}): Promise<UnionCityWarScoreRecordData> {
  if (SERVICE_MOCK_ENABLED) {
    if (params.type === UnionCityWarScoreRecordType.Task) {
      return UnionCityWarScoreRecordTaskMock
    }
    if (params.type === UnionCityWarScoreRecordType.Pk) {
      return UnionCityWarScoreRecordPkMock
    }
    return UnionCityWarScoreRecordGiftMock
  }

  const res = await http.post(
    '/live/activity/union_city_war_score_record',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/union_city_war_pk_list.md */
export async function union_city_war_pk_list(params: {
  page?: number
  page_size?: number
}): Promise<UnionCityWarPkListData> {
  if (SERVICE_MOCK_ENABLED) {
    return UnionCityWarPkListMock
  }

  const res = await http.post(
    '/live/activity/union_city_war_pk_list',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/** @see mockMd/union_city_war_pk_search.md */
export async function union_city_war_pk_search(params: {
  union_id: number
}): Promise<UnionCityWarPkListData> {
  if (SERVICE_MOCK_ENABLED) {
    return UnionCityWarPkSearchMock
  }

  const res = await http.post(
    '/live/activity/union_city_war_pk_search',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}
